import itemInitialValue from './createItemInitialValue'

const initialValue = () => ({
  deductStatus: new Date().toISOString().substring(0, 10),
  items: [itemInitialValue],
})

export default initialValue
